import React, { FC, useContext, useEffect } from 'react';
import Button from '@mui/material/Button';
import Email from '@mui/icons-material/Email';
import { useTranslation } from 'react-i18next';
import { createFetcher } from '../../contexts/Fetcher';
import { OrganizationContext } from '../../contexts/OrganizationContext';
import { AuthContext } from '../../contexts/AuthContext';
import { apiOrganization } from '../../resources/api/apiOrganization';
import { LazyUsersContext } from '../../contexts/LazyUsersContext';

const { useGetOrganizationByName } = apiOrganization;
const OrgFetcher = createFetcher(() => {
  const { organization } = useContext(OrganizationContext);
  return useGetOrganizationByName(organization?.name).execute;
});

const ContactAdminComponent: FC = () => {
  const { identity } = useContext(AuthContext);
  const { data } = useContext(OrgFetcher.Context);
  const { t } = useTranslation();

  const { data: users, requestData: requestUserData } = useContext(LazyUsersContext);

  let contactPersonId = data?.payload.owner_id;
  if (data && data.payload.owner_id === identity?.userId) {
    contactPersonId = data.payload.pixotope_representative;
  }

  useEffect(() => {
    if (contactPersonId) {
      requestUserData(contactPersonId);
    }
  }, [contactPersonId]);

  if (!data || !contactPersonId || !(contactPersonId in users)) return null;

  const contactPerson = users[contactPersonId];

  return (
    <Button
      component="a"
      variant="contained"
      color="primary"
      endIcon={<Email />}
      href={`mailto:${contactPerson.email}`}
    >
      {t('nothing.contactAdmin')}
    </Button>
  );
};

export const ContactAdminButton = () => {
  return (
    <OrgFetcher.WAF>
      <ContactAdminComponent />
    </OrgFetcher.WAF>
  );
};
